import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const NormativasPage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-[#1A3A5F] to-[#4D8BC9] text-white">
        <div className="container mx-auto px-4 py-16">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Normativas Técnicas</h1>
            <p className="text-xl mb-8">
              Conheça as principais normas regulamentadoras e como o Grupo M7 CORP pode ajudar sua empresa a estar em conformidade
            </p>
          </motion.div>
        </div>
      </section>

      {/* Introdução */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold mb-4 text-[#1A3A5F]">Normas Regulamentadoras</h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              As Normas Regulamentadoras (NRs) são disposições complementares ao Capítulo V da CLT, 
              consistindo em obrigações, direitos e deveres a serem cumpridos por empregadores e trabalhadores 
              com o objetivo de garantir trabalho seguro e sadio, prevenindo a ocorrência de doenças e acidentes de trabalho.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Cards das Normativas */}
      <section className="py-8">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* NR-13 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-lg overflow-hidden"
            >
              <div className="h-48 bg-[#1A3A5F] flex items-center justify-center">
                <span className="text-white text-6xl font-bold">NR-13</span>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-[#1A3A5F]">Caldeiras, Vasos de Pressão e Tubulações</h3>
                <p className="text-gray-700 mb-4">
                  Estabelece requisitos mínimos para gestão da integridade estrutural de caldeiras a vapor, vasos de pressão e suas tubulações de interligação.
                </p>
                <ul className="list-disc pl-5 mb-4 text-gray-700">
                  <li>Inspeção de segurança</li>
                  <li>Documentação</li>
                  <li>Capacitação de pessoal</li>
                  <li>Requisitos para instalação</li>
                </ul>
                <Link 
                  to="/normativas/nr13" 
                  className="inline-block bg-[#1A3A5F] hover:bg-[#4D8BC9] text-white font-bold py-2 px-4 rounded transition-colors"
                >
                  Saiba mais
                </Link>
              </div>
            </motion.div>

            {/* NR-11 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-lg overflow-hidden"
            >
              <div className="h-48 bg-[#4D8BC9] flex items-center justify-center">
                <span className="text-white text-6xl font-bold">NR-11</span>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-[#1A3A5F]">Transporte, Movimentação, Armazenagem e Manuseio de Materiais</h3>
                <p className="text-gray-700 mb-4">
                  Estabelece os requisitos de segurança para operação de elevadores, guindastes, transportadores industriais e máquinas transportadoras.
                </p>
                <ul className="list-disc pl-5 mb-4 text-gray-700">
                  <li>Operação segura de equipamentos</li>
                  <li>Capacitação de operadores</li>
                  <li>Inspeção periódica</li>
                  <li>Armazenamento seguro</li>
                </ul>
                <Link 
                  to="/normativas/nr11" 
                  className="inline-block bg-[#4D8BC9] hover:bg-[#1A3A5F] text-white font-bold py-2 px-4 rounded transition-colors"
                >
                  Saiba mais
                </Link>
              </div>
            </motion.div>

            {/* NR-20 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-lg overflow-hidden"
            >
              <div className="h-48 bg-[#1A3A5F] flex items-center justify-center">
                <span className="text-white text-6xl font-bold">NR-20</span>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-[#1A3A5F]">Segurança e Saúde no Trabalho com Inflamáveis e Combustíveis</h3>
                <p className="text-gray-700 mb-4">
                  Estabelece requisitos mínimos para a gestão da segurança e saúde no trabalho contra os fatores de risco de acidentes provenientes das atividades com inflamáveis e combustíveis.
                </p>
                <ul className="list-disc pl-5 mb-4 text-gray-700">
                  <li>Classificação das instalações</li>
                  <li>Capacitação dos trabalhadores</li>
                  <li>Prevenção e controle de vazamentos</li>
                  <li>Plano de Resposta a Emergências</li>
                </ul>
                <Link 
                  to="/normativas/nr20" 
                  className="inline-block bg-[#1A3A5F] hover:bg-[#4D8BC9] text-white font-bold py-2 px-4 rounded transition-colors"
                >
                  Saiba mais
                </Link>
              </div>
            </motion.div>

            {/* NR-33 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-lg overflow-hidden"
            >
              <div className="h-48 bg-[#4D8BC9] flex items-center justify-center">
                <span className="text-white text-6xl font-bold">NR-33</span>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-[#1A3A5F]">Segurança e Saúde nos Trabalhos em Espaços Confinados</h3>
                <p className="text-gray-700 mb-4">
                  Estabelece os requisitos para identificação de espaços confinados e o reconhecimento, avaliação, monitoramento e controle dos riscos existentes.
                </p>
                <ul className="list-disc pl-5 mb-4 text-gray-700">
                  <li>Gestão de riscos específicos</li>
                  <li>Permissão de Entrada e Trabalho</li>
                  <li>Capacitação para trabalhos em espaços confinados</li>
                  <li>Emergência e salvamento</li>
                </ul>
                <Link 
                  to="/normativas/nr33" 
                  className="inline-block bg-[#4D8BC9] hover:bg-[#1A3A5F] text-white font-bold py-2 px-4 rounded transition-colors"
                >
                  Saiba mais
                </Link>
              </div>
            </motion.div>

            {/* NR-35 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-lg overflow-hidden"
            >
              <div className="h-48 bg-[#1A3A5F] flex items-center justify-center">
                <span className="text-white text-6xl font-bold">NR-35</span>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-[#1A3A5F]">Trabalho em Altura</h3>
                <p className="text-gray-700 mb-4">
                  Estabelece os requisitos mínimos e as medidas de proteção para o trabalho em altura, envolvendo o planejamento, a organização e a execução.
                </p>
                <ul className="list-disc pl-5 mb-4 text-gray-700">
                  <li>Análise de risco</li>
                  <li>Sistemas de proteção contra quedas</li>
                  <li>Capacitação e treinamento</li>
                  <li>Permissão de Trabalho</li>
                </ul>
                <Link 
                  to="/normativas/nr35" 
                  className="inline-block bg-[#1A3A5F] hover:bg-[#4D8BC9] text-white font-bold py-2 px-4 rounded transition-colors"
                >
                  Saiba mais
                </Link>
              </div>
            </motion.div>

            {/* Outras Normativas */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-lg overflow-hidden"
            >
              <div className="h-48 bg-[#4D8BC9] flex items-center justify-center">
                <span className="text-white text-5xl font-bold">Outras NRs</span>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-[#1A3A5F]">Demais Normas Regulamentadoras</h3>
                <p className="text-gray-700 mb-4">
                  O Grupo M7 CORP também oferece serviços relacionados a outras normas regulamentadoras aplicáveis à sua indústria.
                </p>
                <ul className="list-disc pl-5 mb-4 text-gray-700">
                  <li>NR-10: Segurança em Instalações e Serviços em Eletricidade</li>
                  <li>NR-12: Segurança no Trabalho em Máquinas e Equipamentos</li>
                  <li>NR-17: Ergonomia</li>
                  <li>NR-23: Proteção Contra Incêndios</li>
                </ul>
                <Link 
                  to="/contato" 
                  className="inline-block bg-[#4D8BC9] hover:bg-[#1A3A5F] text-white font-bold py-2 px-4 rounded transition-colors"
                >
                  Entre em contato
                </Link>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Serviços Relacionados */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold mb-4 text-[#1A3A5F]">Serviços Relacionados às Normativas</h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              O Grupo M7 CORP oferece uma ampla gama de serviços para auxiliar sua empresa a estar em conformidade com as normas regulamentadoras.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Serviço 1 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <div className="w-16 h-16 bg-[#1A3A5F] rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#1A3A5F]">Diagnóstico de Conformidade</h3>
              <p className="text-gray-700 mb-4">
                Avaliação completa da situação atual da empresa em relação às normas aplicáveis, identificando não conformidades e oportunidades de melhoria.
              </p>
              <Link 
                to="/servicos" 
                className="text-[#1A3A5F] hover:text-[#4D8BC9] font-bold transition-colors"
              >
                Saiba mais →
              </Link>
            </motion.div>

            {/* Serviço 2 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <div className="w-16 h-16 bg-[#4D8BC9] rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#1A3A5F]">Elaboração de Documentação</h3>
              <p className="text-gray-700 mb-4">
                Desenvolvimento de toda a documentação técnica exigida pelas normas, incluindo prontuários, registros de segurança, procedimentos e planos de inspeção.
              </p>
              <Link 
                to="/servicos" 
                className="text-[#4D8BC9] hover:text-[#1A3A5F] font-bold transition-colors"
              >
                Saiba mais →
              </Link>
            </motion.div>

            {/* Serviço 3 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <div className="w-16 h-16 bg-[#1A3A5F] rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#1A3A5F]">Inspeções e Ensaios</h3>
              <p className="text-gray-700 mb-4">
                Realização de inspeções periódicas e extraordinárias, ensaios não destrutivos e testes de integridade conforme exigido pelas normas.
              </p>
              <Link 
                to="/servicos" 
                className="text-[#1A3A5F] hover:text-[#4D8BC9] font-bold transition-colors"
              >
                Saiba mais →
              </Link>
            </motion.div>

            {/* Serviço 4 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <div className="w-16 h-16 bg-[#4D8BC9] rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#1A3A5F]">Treinamentos</h3>
              <p className="text-gray-700 mb-4">
                Capacitação de operadores, supervisores e equipes de manutenção conforme exigido pelas normas, com emissão de certificados reconhecidos.
              </p>
              <Link 
                to="/servicos" 
                className="text-[#4D8BC9] hover:text-[#1A3A5F] font-bold transition-colors"
              >
                Saiba mais →
              </Link>
            </motion.div>

            {/* Serviço 5 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <div className="w-16 h-16 bg-[#1A3A5F] rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#1A3A5F]">Projetos de Adequação</h3>
              <p className="text-gray-700 mb-4">
                Desenvolvimento e execução de projetos para adequação de equipamentos e instalações às exigências normativas, incluindo cálculos e especificações técnicas.
              </p>
              <Link 
                to="/servicos" 
                className="text-[#1A3A5F] hover:text-[#4D8BC9] font-bold transition-colors"
              >
                Saiba mais →
              </Link>
            </motion.div>

            {/* Serviço 6 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <div className="w-16 h-16 bg-[#4D8BC9] rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#1A3A5F]">Assessoria em Fiscalizações</h3>
              <p className="text-gray-700 mb-4">
                Suporte técnico durante fiscalizações dos órgãos competentes, incluindo acompanhamento presencial, esclarecimento de dúvidas e defesa técnica.
              </p>
              <Link 
                to="/servicos" 
                className="text-[#4D8BC9] hover:text-[#1A3A5F] font-bold transition-colors"
              >
                Saiba mais →
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Benefícios */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold mb-4 text-[#1A3A5F]">Benefícios da Conformidade Normativa</h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Estar em conformidade com as normas regulamentadoras traz diversos benefícios para sua empresa, além de cumprir as obrigações legais.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <h3 className="text-xl font-bold mb-4 text-[#1A3A5F]">Benefícios para a Empresa</h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-500 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700">Redução de riscos de acidentes e incidentes</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-500 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700">Prevenção de multas e sanções legais</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-500 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700">Redução de custos com paradas não programadas</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-500 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700">Aumento da vida útil dos equipamentos</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-500 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700">Melhoria da imagem corporativa</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-500 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700">Facilidade na obtenção de certificações (ISO 45001, etc.)</span>
                </li>
              </ul>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <h3 className="text-xl font-bold mb-4 text-[#1A3A5F]">Benefícios para os Trabalhadores</h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-500 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700">Ambiente de trabalho mais seguro e saudável</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-500 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700">Redução de doenças ocupacionais</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-500 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700">Maior capacitação e conhecimento técnico</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-500 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700">Procedimentos claros para situações de emergência</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-500 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700">Maior confiança na operação dos equipamentos</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-500 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700">Melhor qualidade de vida no trabalho</span>
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#1A3A5F] text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Precisa de Ajuda com Normativas?</h2>
            <p className="text-xl mb-8">
              Nossa equipe de especialistas está pronta para ajudar sua empresa a estar em conformidade com todas as normas regulamentadoras aplicáveis ao seu negócio.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link 
                to="/contato" 
                className="bg-white text-[#1A3A5F] hover:bg-gray-100 font-bold px-8 py-3 rounded-md transition-colors"
              >
                Solicite uma Avaliação
              </Link>
              <Link 
                to="/servicos" 
                className="bg-transparent border-2 border-white hover:bg-white hover:text-[#1A3A5F] text-white font-bold px-8 py-3 rounded-md transition-colors"
              >
                Conheça Nossos Serviços
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NormativasPage;
